'use client'
import { useState } from 'react'
import Link from 'next/link'
import { createClient } from '@/lib/supabase/client'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const supabase = createClient()
    await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    })
    setSent(true)
  }

  if (sent) return (
    <div className="space-y-4 text-center">
      <p className="text-sm">Instructions sent to {email}</p>
      <Link href="/login" className="text-teal-600 hover:underline text-sm">Back to Sign In</Link>
    </div>
  )

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Reset Password</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="forgot-email">Email</Label>
          <Input id="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <Button type="submit" className="w-full">Send Reset Link</Button>
      </form>
      <p className="text-center">
        <Link href="/login" className="text-sm text-teal-600 hover:underline">Back</Link>
      </p>
    </div>
  )
}
